import { defineApiGetCall } from './define-api-get-call';
import { defineApiPostCall } from './define-api-post-call';
export class ApiCallDefinition {
    constructor(route, addTo, secure) {
        this.route = route;
        this.addTo = addTo;
        this.secure = secure;
    }
}
export class ApiGetCallDefinition extends ApiCallDefinition {
    constructor(route, definition, namespace, secure) {
        super(route, (api) => defineApiGetCall(api, route, definition, namespace, secure), secure);
        this.definition = definition;
    }
    inNamespace(namespace) {
        return new ApiGetCallDefinition(this.route, this.definition, namespace, this.secure);
    }
    forServer(app, params) {
        app.get(this.definition.route, params.handler);
        return this;
    }
    createHandler(handler) {
        return async (request, response) => {
            const result = await handler(request, response);
            if (typeof result !== 'undefined') {
                response.json(result);
            }
        };
    }
    toDefinition() {
        return this;
    }
}
export class ApiPostCallDefinition extends ApiCallDefinition {
    constructor(route, definition, namespace, secure) {
        super(route, (api) => defineApiPostCall(api, route, definition, namespace, secure), secure);
        this.definition = definition;
    }
    inNamespace(namespace) {
        return new ApiPostCallDefinition(this.route, this.definition, namespace, this.secure);
    }
    createHandler(handler) {
        return async (request, response) => {
            const result = await handler(request, response, request.body);
            if (typeof result !== 'undefined') {
                response.json(result);
            }
        };
    }
    forServer(app, params) {
        app.post(this.definition.route, async (request, response) => {
            await params.handler(request, response, params.body(request));
        });
        return this;
    }
    toDefinition() {
        return this;
    }
}
